import { Maintenance } from 'models/Maintenance';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const MaintenanceActionType = {
    FETCH_MAINTENANCES: 'FETCH_MAINTENANCES',
    FETCH_MAINTENANCES_SUCCESS: 'FETCH_MAINTENANCES_SUCCESS',
    ADD_MAINTENANCE: 'ADD_MAINTENANCE',
    ADD_MAINTENANCE_SUCCESS: 'ADD_MAINTENANCE_SUCCESS',
    EDIT_MAINTENANCE: 'EDIT_MAINTENANCE',
    EDIT_MAINTENANCE_SUCCESS: 'EDIT_MAINTENANCE_SUCCESS',
    DELETE_MAINTENANCE: 'DELETE_MAINTENANCE',
    DELETE_MAINTENANCE_SUCCESS: 'DELETE_MAINTENANCE_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMaintenancesAction {
    type: typeof MaintenanceActionType.FETCH_MAINTENANCES
    payload: ApiPayload,
    returnPayload: Maintenance[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMaintenancesAction {
    type: typeof MaintenanceActionType.ADD_MAINTENANCE
    payload: ApiPayload,
    returnPayload: Maintenance,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMaintenancesAction {
    type: typeof MaintenanceActionType.DELETE_MAINTENANCE
    payload: ApiPayload,
    returnPayload: Maintenance,
    meta: {
        isApiCall: boolean
    },
}

export type IMaintenanceActions = IFetchMaintenancesAction | IAddMaintenancesAction | IDeleteMaintenancesAction

const baseUrl = 'api/maintenances';
export class MaintenanceActions {
    public static fetchMaintenances(token: string): IMaintenanceActions {
        return {
            type: MaintenanceActionType.FETCH_MAINTENANCES,
            payload: Api.fetchApiCall(baseUrl, token, MaintenanceActionType.FETCH_MAINTENANCES_SUCCESS, MaintenanceActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMaintenance(token: string, maintenance: Maintenance): IMaintenanceActions {
        return {
            type: MaintenanceActionType.ADD_MAINTENANCE,
            payload: Api.postApiCall(baseUrl, token, MaintenanceActionType.ADD_MAINTENANCE_SUCCESS, MaintenanceActionType.API_ERROR, maintenance),
            returnPayload: Maintenance.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editMaintenance(token: string, maintenance: Maintenance): IMaintenanceActions {
        return {
            type: MaintenanceActionType.EDIT_MAINTENANCE,
            payload: Api.putApiCall(baseUrl + '/' + maintenance.id, token, MaintenanceActionType.EDIT_MAINTENANCE_SUCCESS, MaintenanceActionType.API_ERROR, maintenance),
            returnPayload: Maintenance.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMaintenance(token: string, id: number): IMaintenanceActions {
        return {
            type: MaintenanceActionType.DELETE_MAINTENANCE,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MaintenanceActionType.DELETE_MAINTENANCE_SUCCESS, MaintenanceActionType.API_ERROR, true),
            returnPayload: Maintenance.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}